module.exports = __webpack_public_path__ + "img/tablet-bar.1f0c0df5.webp";